import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Layouts
import AdminLayout from './layouts/AdminLayout';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import ProductForm from './pages/ProductForm';
import Services from './pages/Services';
import ServiceForm from './pages/ServiceForm';
import Partners from './pages/Partners';
import PartnerForm from './pages/PartnerForm';
import Contacts from './pages/Contacts';
import ContactDetails from './pages/ContactDetails';
import UserProfile from './pages/UserProfile';
import CompanyInfo from './pages/CompanyInfo';
import ContentManagement from './pages/ContentManagement';
import NotFound from './pages/NotFound';

// Auth Guard Component
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const isAuthenticated = localStorage.getItem('token') !== null;
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        
        <Route path="/" element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }>
          <Route index element={<Dashboard />} />
          <Route path="products" element={<Products />} />
          <Route path="products/new" element={<ProductForm />} />
          <Route path="products/edit/:id" element={<ProductForm />} />
          <Route path="services" element={<Services />} />
          <Route path="services/new" element={<ServiceForm />} />
          <Route path="services/edit/:id" element={<ServiceForm />} />
          <Route path="partners" element={<Partners />} />
          <Route path="partners/new" element={<PartnerForm />} />
          <Route path="partners/edit/:id" element={<PartnerForm />} />
          <Route path="contacts" element={<Contacts />} />
          <Route path="contacts/:id" element={<ContactDetails />} />
          <Route path="profile" element={<UserProfile />} />
          <Route path="company-info" element={<CompanyInfo />} />
          <Route path="content-management" element={<ContentManagement />} />
        </Route>
        
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
